import React, {PureComponent} from 'react'
import {Divider, Header, Icon} from "semantic-ui-react"

export default class ProjectCard extends PureComponent {
  render() {
    const {imgUrl, title, ghClientUrl, ghServerUrl, ghUrl, shortDesc} = this.props.project

    return (
      <div>
        <Header as='h3' inverted>
            {title}
        </Header>
        <Divider inverted />
        <p>
            {shortDesc}
        </p>
        <div>
          <img
            src={imgUrl}
            alt='screenshot'
            style={{
              width: 220,
              height: 220,
              objectFit: 'cover'
            }}
          />
        </div>
        <Divider inverted />
        {
          ghClientUrl &&
          <div>
            <a href={ghClientUrl}>
              <Icon name='github' />
              View client on GitHub
            </a>
          </div>
        }
        {
          ghServerUrl &&
          <div>
            <a href={ghServerUrl}>
              <Icon name='github' />
              View backend on GitHub
            </a>
          </div>
        }
        {
          ghUrl &&
          <div>
          <a href={ghUrl}>
            <Icon name='github' />
            View on GitHub
          </a>
          </div>
        }
        <Divider inverted/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ProjectCard.js